import React, { useState } from 'react';
import styles from './Form.module.css';
import { useTranslation } from 'react-i18next';

import { Button, TextInput, PasswordInput } from '@mantine/core';
import { useForm } from '@mantine/form';
import { Link, useNavigate } from 'react-router-dom';
import useAuth from '@hooks/useAuth/useAuth';

import Approve from '@components/Approve';
import { emailValidator, requiredValidator } from '@utils/validators';

const Form = () => {
  const { t } = useTranslation();
  const [registerValues, setRegisterValues] = useState({});
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [_, { login, sendAgain }] = useAuth();

  const form = useForm({
    mode: 'uncontrolled',
    initialValues: {
      login: '',
      password: '',
    },

    validate: {
      login: value => emailValidator(value, t),
      password: (value) => requiredValidator(value, t)
    },
  });

  const onSuccess = ({ admin }) => {
    window.gtag('event', 'action_login')

    navigate(admin ? '/organizations' : '/places')
  }

  const onInactive = (val) => {
    setRegisterValues(val);
  }

  const toRegister = () => {
    setRegisterValues(null)
  }

  const sendAgaing = async () => {
    const email = registerValues.login
    await sendAgain({ email });
  }

  const handleSubmit = async (values) => {
    setLoader(true);
    const submitErrors = await login(values, onSuccess, onInactive);

    if (submitErrors?.length > 0) {
      submitErrors.forEach(error => {
        switch (error.code) {
          case 'P001':
            form.setErrors({
              login: ' ',
              password: t('login.error', { email: values.email })
            })

            break;

          default:
            break;
        }
      })
    }

    setLoader(false);
  }

  const handleBlur = (type) => {
    const value = form.getValues()[type]
    const data = value.replace(/^(\s|\u00A0)+|(\s|\u00A0)+$/g, "")

    form.setValues({
      [type]: data
    })

    const error = form.validateField(type)

    if (error) {
      form.setErrors({ [type]: error.error });
    }
  }

  return (
    <div className={styles.wrapper}>
      {!registerValues?.login && (
        <div>
          <div className={styles.title}>
            {t('logIn')}
          </div>

          <form
            className={styles.form}
            onSubmit={form.onSubmit(handleSubmit)}
          >
            <TextInput
              label={t('email.label')}
              placeholder={t('email.placeholder')}
              key={form.key('login')}
              {...form.getInputProps('login')}
              onBlur={() => handleBlur('login')}
            />

            <div className={styles.separator} />

            <PasswordInput
              label={t('password.label.short')}
              key={form.key('password')}
              placeholder={t('password.placeholder')}
              {...form.getInputProps('password')}
            />

            <div className={styles.separator} />

            <Link to='/forget' className={styles.forget}>
              <div className={styles.forget}>
                {t('password.forgot')}
              </div>
            </Link>

            <Button
              className={styles.button}
              fullWidth type="submit"
              loading={loader}
            >
              {t('enter')}
            </Button>

            <div className={styles.or}>
              <div className={styles.line} />

              {t('or')}

              <div className={styles.line} />
            </div>

            <Link to='/sign_in' className={styles.link}>
              <Button
                className={styles.button}
                fullWidth type="submit"
              >
                {t('create')}
              </Button>
            </Link>
          </form>
        </div>
      )}

      {registerValues?.login && (
        <Approve
          email={registerValues?.login}
          toRegister={toRegister}
          sendAgaing={sendAgaing}
        />
      )}
    </div>
  )
}

export default Form;
